import antdEn from 'antd/lib/locale-provider/en_US';
// import appLocaleData from "react-intl/locale-data/la";
import laMessages from '../locales/la_LA/index';
const LaLang = {
  messages: {
    ...laMessages,
  },
  antd: antdEn,
  locale: 'la-LA',
  // data: appLocaleData
};
export default LaLang;
